<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>

export default {
    name: "App",
};
</script>

<style>
html {
    height: 100%;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
}

body {
    width: 100%;
    margin: 0;
    height: calc(100% - 76px);
    font-family: "Microsoft YaHei", "Segoe UI", Verdana, Helvetica, Sans-Serif;
    background-color: #192d40;
    background: url(./icon/bg.png) no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    font-size: 16px;
    overflow: hidden;
}
p {
    margin-top: 0;
    margin-bottom: 0;
}
.container {
    height: 100%;
}
.footer {
    position: fixed;
    padding: 20px;
    left: 0px;
    bottom: 0px;
    width: 100%;
    text-align: center;
    /* line-height: 75px; */
    background: #2f4054;
    color: #ebebeb;
    font-size: 12px;
    line-height: 18px;
}
</style>
